import { useQuery } from "@tanstack/react-query";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setCurrentUser } from "../../redux/reducers/userReducer";
import { useCurrentUserProfile } from "../../modules/auth/api/useCurrentUserProfile";
import { getOrganizationsOptions } from "../../modules/admin/api/useOrganizations";
import { useSetOrgId } from "../../modules/admin/api/useSetCurrentOrg";

const ProfileValidator = () => {
  const user = useAppSelector((state) => state.user);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const dispatch = useAppDispatch();
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const currentUserQuery = useCurrentUserProfile();
  const orgsQuery = useQuery({ ...getOrganizationsOptions({ channel }), enabled: isAuthenticated });
  const setOrgMutation = useSetOrgId();

  const userProfileOrgId = currentUserQuery.data?.organization_id;

  // Wait for both queries to be ready before validating org
  if (currentUserQuery.isSuccess && !currentUserQuery.isFetching && orgsQuery.isSuccess && !orgsQuery.isFetching) {
    const orgs = orgsQuery.data;
    const firstOrgId = orgs[0]?.id;

    // org.id is number, user.organization_id is string - convert for comparison
    const currentOrgInList = orgs.some((org) => org.id.toString() === user.organization_id);
    const userProfileOrgInList = userProfileOrgId && orgs.some((org) => org.id.toString() === userProfileOrgId);

    let targetOrgId: string | null = null;

    // Priority 1: userProfile org differs AND is in list → sync to it
    if (userProfileOrgId && userProfileOrgId !== user.organization_id && userProfileOrgInList) {
      targetOrgId = userProfileOrgId;
    }
    // Priority 2: current org not in list → fallback to first
    else if (!currentOrgInList && firstOrgId) {
      targetOrgId = firstOrgId.toString();
    }

    if (targetOrgId) {
      dispatch(setCurrentUser({ organization_id: targetOrgId }));
      setOrgMutation.mutate(parseInt(targetOrgId));
    }
  }

  return null;
};

export default ProfileValidator;
